export default "data:image/gif;base64,R0lGODlhEAAJAKEAAP///wAAAP///////yH+EUNyZWF0ZWQgd2l0aCBHSU1QACH5BAEKAAEALAAAAAAQAAkAAAIKjI+py+0Po5yUFQA7"